import React, { useCallback, useEffect, useState } from 'react';
import { Text, FlatList, TouchableOpacity } from 'react-native';
import { usePersistBoundStore } from '@/services/zustand/Store';
import { useFocusEffect } from 'expo-router';
import OnboardingOverlay from '../Onboarding';
import { useHandleSelectMagazine } from '@/services/PDF/useHandleSelectMagazine';
import { useFetchArchiveMagazines } from '@/services/FetchMagazines';
import ListItem_Magazine from './ListItem_Magazine';
import { useFilterMagazines } from '@/services/PDF/filterMagazines';
import { useHandleDeleteMagazine } from '@/services/PDF/useHandleDeleteMagazine';
import { Magazine } from '@/services/datatypes/pdf';

export default function Archive() {
  const [availableMagazines, setAvailableMagazines] = useState<Magazine[]>([]);
  const [editionFilter, setEditionFilter] = useState<string | null>(null);
  const [dateFilter, setDateFilter] = useState<string | null>(null);
  const favouriteEdition = usePersistBoundStore((state) => state.favouriteEdition);
  const fetchArchiveMagazines = useFetchArchiveMagazines();
  const handleSelect = useHandleSelectMagazine();
  const handleDelete = useHandleDeleteMagazine();
  const filteredMagazines = useFilterMagazines(availableMagazines, dateFilter, null); //does not provide an editionFilter because it is the archive

  useFocusEffect(
    useCallback(() => {
      const prepare = async () => {
        const magazines = await fetchArchiveMagazines();
        setAvailableMagazines(magazines);
      };
      prepare();
    }, [])
  );

  useEffect(() => setEditionFilter(favouriteEdition), [favouriteEdition])
  //useEffect(() => setDateFilter(favouriteDate), [favouriteDate]);
  const clearFilters = () => setDateFilter(null);

  const handleDeleteWithCallback = useCallback(
    (magazine: Magazine) => {
      handleDelete(magazine, (deletedMagazine) => {
        setAvailableMagazines((prevMagazines) =>
          prevMagazines.filter(
            (m) => m.date !== deletedMagazine.date || m.edition !== deletedMagazine.edition
          )
        );
      });
    },
    [handleDelete]
  );

  const renderItem = ({ item, index }: { item: Magazine, index: number }) => {
    let size: number = 0;
    if (item.pageFiles) {
      item.pageFiles.map(pf => {
        size = size + pf.filesize;
      })
    }
    return (
      <ListItem_Magazine
        index={index}
        magazine={item}
        filesize={(size / 1024 / 1024).toFixed(2).toString()}
        handleButtonPress={handleSelect}
        handleDeleteButtonPress={() => handleDeleteWithCallback(item)}
      />
    );
  };

  return (
    <>
      <OnboardingOverlay page="archiv" />
      <FlatList
        data={filteredMagazines}
        renderItem={renderItem}
        keyExtractor={(item) => `${item.date}-${item.edition}`}
      />
      {dateFilter && (
        <TouchableOpacity style={{ alignSelf: 'center', height: 90 }} onPress={clearFilters}>
          <Text style={{ fontSize: 26, color: '#999' }}>Filter löschen</Text>
        </TouchableOpacity>
      )}
    </>
  );
}
